import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import DateRangePicker from './DateRangePicker';
import './date_overrides.scss';
import { connect } from 'react-redux';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import _ from 'lodash';
import Const from './Const';

const I18N_NAME = 'common.lstLabelCalendar.';

const formatDate = 'MM/DD/YYYY';
const arrayFormatDate = ['MM/DD/YYYY', 'M/DD/YYYY', 'MM/D/YYYY', 'M/D/YYYY'];
class Calendar extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      startDate: props.startDate,
      endDate: props.endDate,
      focusedInput:
        props.startDate && props.endDate
          ? 'endDate'
          : props.startDate
          ? 'endDate'
          : 'startDate',
      startDatePlaceholderText: I18n.t(`${I18N_NAME}formatDate`),
      endDatePlaceholderText: I18n.t(`${I18N_NAME}formatDate`),
      checkStartDateInput: true,
      checkEndDateInput: true,
      mesWarStartDate:
        props.condition === Const.COMPARE_CURRENT_DATE && !props.startDate
          ? 'Do not blank'
          : '',
      mesWarEndDate:
        props.condition === Const.COMPARE_CURRENT_DATE && !props.endDate
          ? 'Do not blank'
          : '',
      startDateString: props.startDate ? props.startDate + '' : null,
      endDateString: props.endDate ? props.endDate + '' : null,
      isEndDateValid: true,
      isStartDateValid: true,
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    let rect = ReactDOM.findDOMNode(this);
    if (rect != null && rect.closest('.lm_stack')) {
      let rectParentStack = rect.closest('.lm_stack').getBoundingClientRect();
      let rectCalender = rect.getBoundingClientRect();
      let parrentChild = this.props.parentRef
        ? this.props.parentRef
        : rect.parentElement;
      let rectParentChild = parrentChild.getBoundingClientRect();
      let right = 0;
      if (rectCalender.right > rectParentStack.right) {
        let spaceChildStack = Math.floor(
          rectParentStack.right - rectParentChild.right,
        );
        let spaceCalenderStack = Math.floor(
          rectParentStack.right - rectCalender.right,
        );
        if (spaceChildStack === spaceCalenderStack) {
          right = spaceChildStack;
        } else {
          right =
            rectParentChild.right > rectParentStack.right
              ? rectParentChild.right -
                rectCalender.right -
                rectParentChild.width +
                rectCalender.width
              : 0;
        }
        let xPosition = rectCalender.x;
        if (xPosition < rectParentStack.left) {
          right = rectParentStack.left - rectParentChild.left;
          rect.style.right = right + 'px ';
        } else if (rectCalender.right > rectParentStack.right) {
          rect.style.right = right + 'px ';
        } else if (rectParentStack.right > rectParentChild.right) {
          // rect.style.left =  rectParentStack.left -  rectParentChild.right + 'px';
          // rect.style.left = '0px';
        } else {
          rect.style.right = right + 'px ';
        }
      } else {
        let positionLeftCalendar = rectParentChild.left + rectCalender.width;
        if (rectCalender.left < 0) {
          rect.style.left = rectParentStack.left - rectParentChild.left + 'px';
        } else if (positionLeftCalendar < rectParentStack.right) {
          // rect.style.left = '0px ';
        }
      }
    }
  }

  componentWillUnmount() {
    this.setState({ ...this.initialState });
  }

  renderButtonApply = status => {
    if (status) {
      return (
        <button
          className="apply btn-apply-cus apply-calendar"
          onClick={() => {
            this.props.handleDateApply(
              this.state.startDate,
              this.state.endDate,
            );
          }}
        >
          {I18n.t(`${I18N_NAME}apply`)}
        </button>
      );
    } else {
      return (
        <button className="apply btn-apply-cus apply-calendar disable">
          {I18n.t(`${I18N_NAME}apply`)}
        </button>
      );
    }
  };

  returnMesWarningStart = (condition, startDate, startDateString) => {
    if (
      !_.isEmpty(startDateString) &&
      !this.checkFormatDate(startDate || startDateString)
    ) {
      return 'Wrong format' + formatDate;
    }

    if (condition === Const.COMPARE_CURRENT_DATE) {
      if (_.isEmpty(startDateString) && startDate === null) {
        return 'Do not blank';
      }
      if (startDate !== null && this.checkCompareDate(startDate)) {
        return 'do not exceed the current time';
      }
      return '';
    }
    return null;
  };

  returnMesWarningEnd = (condition, endDate, endDateString, startDate) => {
    if (
      !_.isEmpty(endDateString) &&
      !this.checkFormatDate(endDate || endDateString)
    ) {
      return 'Wrong format' + formatDate;
    }
    if (startDate !== null && endDate !== null) {
      if (this.checkCompareStartDateToEndDate(startDate, endDate))
        return 'The end date cannot be greater than the current date';
    }
    if (condition === Const.COMPARE_CURRENT_DATE) {
      if (_.isEmpty(endDateString) && endDate === null) {
        return 'Do not blank';
      }
      if (endDate !== null && this.checkCompareDate(endDate)) {
        return 'do not exceed the current time';
      }
      return '';
    }
    return null;
  };

  handleButtonApply = condition => {
    const isShow = true;
    if (condition === Const.FORMAT_DATE) {
      return !this.state.checkStartDateInput
        ? this.renderButtonApply(!isShow)
        : !this.state.checkEndDateInput
        ? this.renderButtonApply(!isShow)
        : this.renderButtonApply(isShow);
    }

    if (condition === Const.COMPARE_CURRENT_DATE) {
      return !this.state.checkStartDateInput || !this.state.checkEndDateInput
        ? this.renderButtonApply(!isShow)
        : this.renderButtonApply(isShow);
    }

    return this.renderButtonApply(isShow);
  };

  checkFormatDate = valueDate => {
    return moment(valueDate, arrayFormatDate, true).isValid();
  };

  checkCompareDate = valueDate => {
    const startOfDate = valueDate.startOf('day');
    const startOfCurrentDate = moment().startOf('day');
    return startOfDate.diff(startOfCurrentDate, 'day') > 0;
  };

  checkCompareStartDateToEndDate = (startDate, endDate) => {
    return endDate.diff(startDate, 'day') < 0;
  };

  handleDate = ({ startDate, endDate, startDateString, endDateString }) => {
    const condition = this.props.condition
      ? this.props.condition
      : Const.FORMAT_DATE;
    const mesWarStartDate = this.returnMesWarningStart(
      condition,
      startDate,
      startDateString,
    );
    const mesWarEndDate = this.returnMesWarningEnd(
      condition,
      endDate,
      endDateString,
      startDate,
    );
    this.setState({
      mesWarStartDate,
      mesWarEndDate,
      checkStartDateInput: _.isEmpty(mesWarStartDate),
      checkEndDateInput: _.isEmpty(mesWarEndDate),
      startDate,
      endDate,
      startDateString,
      endDateString,
    });
  };

  formatInputFocus = (
    endDate,
    startDate,
    endDateString,
    startDateString,
    focusedInput,
  ) => {
    let obj = {};
    if (focusedInput !== null) {
      obj = {
        focusedInput,
      };

      if (focusedInput === 'startDate') {
        if (endDateString) {
          obj.endDate = this.checkFormatDate(endDateString)
            ? moment(endDateString, formatDate)
            : endDate;
        }
      }
      if (focusedInput === 'endDate') {
        if (startDateString) {
          obj.startDate = this.checkFormatDate(startDateString)
            ? moment(startDateString, formatDate)
            : startDate;
        }
      }
    } else {
      if (
        (this.checkFormatDate(endDateString) &&
          !moment(endDateString, formatDate, true).isValid()) ||
        (this.checkFormatDate(startDateString) &&
          !moment(startDateString, formatDate, true).isValid())
      ) {
        obj.endDate = this.checkFormatDate(endDateString)
          ? moment(endDateString, formatDate)
          : endDate;
        obj.startDate = this.checkFormatDate(startDateString)
          ? moment(startDateString, formatDate)
          : startDate;
      }
    }
    if (!_.isEmpty(obj)) {
      this.setState({ ...obj });
    }
  };

  render() {
    if (this.props.i18n.locale === 'en') {
      moment.locale('en');
    } else {
      moment.locale('vi-VN');
    }
    const { modifyStyle = {} } = this.props;
    const condition = this.props.condition
      ? this.props.condition
      : Const.FORMAT_DATE;

    const {
      endDate,
      startDate,
      startDateString,
      endDateString,
      mesWarEndDate,
      mesWarStartDate,
    } = this.state;
    return (
      <div className="Calendar-container" style={modifyStyle}>
        <div className="Calendar-wraper">
          <DateRangePicker
            initialVisibleMonth={() => moment().subtract(1, 'month')}
            showDefaultInputIcon={true}
            startDateId="startDate"
            endDateId="endDate"
            isEndDateValid={_.isEmpty(mesWarEndDate)}
            isStartDateValid={_.isEmpty(mesWarStartDate)}
            startDatePlaceholderText={this.state.startDatePlaceholderText}
            endDatePlaceholderText={this.state.endDatePlaceholderText}
            customInputIcon={<div>{I18n.t(`${I18N_NAME}from`)}</div>}
            customArrowIcon={<div>{I18n.t(`${I18N_NAME}to`)}</div>}
            startDate={this.state.startDate || null}
            endDate={this.state.endDate || null}
            onDatesChange={this.handleDate}
            focusedInput={this.state.focusedInput}
            condition={condition}
            mesWarStartDate={mesWarStartDate}
            mesWarEndDate={mesWarEndDate}
            startDateString={startDateString}
            endDateString={endDateString}
            onFocusChange={focusedInput => {
              this.formatInputFocus(
                endDate,
                startDate,
                endDateString,
                startDateString,
                focusedInput,
              );
            }}
            keepOpenOnDateSelect
            //inputIconPosition={ICON_AFTER_POSITION}
            isOutsideRange={() => false}
            transitionDuration={0}
          />
          {this.handleButtonApply(condition ? condition : Const.FORMAT_DATE)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ i18n }) => ({ i18n });

export default connect(mapStateToProps)(Calendar);
